import script from "./GiaThanhSuaChuaCacCapTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./GiaThanhSuaChuaCacCapTable.vue?vue&type=script&lang=ts&setup=true"

import "./GiaThanhSuaChuaCacCapTable.vue?vue&type=style&index=0&id=6cf869b0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cf869b0"]])

export default __exports__